import { render, staticRenderFns } from "./GroupMargin.vue?vue&type=template&id=a18b61dc&scoped=true"
import script from "./GroupMargin.vue?vue&type=script&lang=js"
export * from "./GroupMargin.vue?vue&type=script&lang=js"
import style0 from "./GroupMargin.vue?vue&type=style&index=0&id=a18b61dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18b61dc",
  null
  
)

export default component.exports